import { Icon } from '@evertrue/et-components';
import { PropTypes } from 'base/react-libs';
import { useEffect } from 'react';
import { loadMoreActiveConstituents } from './api-requests/journey-details';
import { useGlobalJourneyProvider } from 'apps/journeys/context/global-journey-context';

const JourneyActiveSearchBar = ({
  journeyId,
  userId,
  searchParam = '',
  setSearchParam = () => {},
  optionalStateManagementFunction = () => {},
}) => {
  const { navigateFrom, setNavigateFrom } = useGlobalJourneyProvider();

  useEffect(() => {
    const searchConstituents = async () => {
      const {
        active_contact_journeys_paginated_by_user: userContacts,
        active_contact_journeys_paginated: allContacts,
      } = await loadMoreActiveConstituents(journeyId, userId, searchParam);

      optionalStateManagementFunction('searchActiveConstituents', { userContacts, allContacts, page: 1 });
    };

    searchConstituents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam]);

  //When navigating to constituents will load this
  useEffect(() => {
    const searchConstituents = async (search) => {
      const {
        active_contact_journeys_paginated_by_user: userContacts,
        active_contact_journeys_paginated: allContacts,
      } = await loadMoreActiveConstituents(journeyId, userId, search);

      optionalStateManagementFunction('searchActiveConstituents', { userContacts, allContacts, page: 1 });
    };

    if (navigateFrom) {
      const name = navigateFrom?.contactName.split(' ');
      setSearchParam(name[0]);
      searchConstituents(name[0]);
      setNavigateFrom(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigateFrom, setSearchParam, setNavigateFrom]);

  return (
    <span className="search-box">
      <Icon icon={'search'} className={'search-box--search-icon'} />
      <input
        className="search-box--input"
        type="search"
        value={searchParam}
        placeholder={'Search Active Constituents'}
        onChange={(e) => setSearchParam(e.target.value)}
      />
    </span>
  );
};

JourneyActiveSearchBar.propTypes = {
  journeyId: PropTypes.number,
  userId: PropTypes.number,
  searchParam: PropTypes.string,
  setSearchParam: PropTypes.func,
  optionalStateManagementFunction: PropTypes.func,
};

export default JourneyActiveSearchBar;
